if (!document.getElementById('quantity-price-total-styles')) {
  const style = document.createElement('style');
  style.id = 'quantity-price-total-styles';
  style.textContent = `
    quantity-price-total {
      display: none;
    }
    quantity-price-total.wt-qty-visible {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 8px 16px;
      border: 1px solid var(--color-border);
      border-radius: var(--border-radius-button);
      margin-top: 8px;
      font-family: var(--font-price);
      font-size: calc(var(--font-base-size) - 2px);
      line-height: 1;
      color: var(--color-body-text);
    }
    quantity-price-total .wt-quantity-total__price {
      font-weight: 600;
    }
    quantity-price-total .wt-qty-spinner {
      width: 1em;
      height: 1em;
      border: 1.5px solid currentColor;
      border-top-color: transparent;
      border-radius: 50%;
      animation: wt-qty-spin 0.7s linear infinite;
      display: inline-block;
      flex-shrink: 0;
      vertical-align: middle;
    }
    @keyframes wt-qty-spin {
      to { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
}

if (!customElements.get('quantity-price-total')) {
  customElements.define(
    'quantity-price-total',
    class QuantityPriceTotal extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.unitPriceRaw = Number(this.dataset.unitPriceRaw || 0);
        this._debounceTimer = null;

        const form = document.getElementById(this.dataset.productFormId);
        this.qtyInput = form?.querySelector('input.js-counter-quantity');

        if (this.qtyInput) {
          this.qtyInput.addEventListener('input', () => this._onQtyChange());
          this.qtyInput.addEventListener('change', () => this._onQtyChange());
        }

        this._bindSubWidget();

        this._unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          if (event.data.variant?.price != null) {
            this.unitPriceRaw = event.data.variant.price;
          }
          setTimeout(() => {
            this._bindSubWidget();
            this.recalculate();
          }, 0);
        });
      }

      disconnectedCallback() {
        if (this._unsubVariant) this._unsubVariant();
        clearTimeout(this._debounceTimer);
      }

      _getSection() {
        return (
          document.getElementById(`shopify-section-${this.sectionId}`) ||
          this.closest('.shopify-section, section')
        );
      }

      _bindSubWidget() {
        const section = this._getSection();
        const subWidget = section?.querySelector('sub-widget');
        if (!subWidget || subWidget === this._boundSubWidget) return;
        this._boundSubWidget = subWidget;
        subWidget.addEventListener('click', () => setTimeout(() => this._onQtyChange(), 0));
        subWidget.addEventListener('change', () => setTimeout(() => this._onQtyChange(), 0), true);
      }

      _onQtyChange() {
        const qty = parseInt(this.qtyInput?.value || '1', 10);
        if (!qty || qty <= 1) {
          this.classList.remove('wt-qty-visible');
          clearTimeout(this._debounceTimer);
          return;
        }
        this._showSpinner();
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => this.recalculate(), ON_CHANGE_DEBOUNCE_TIMER);
      }

      _showSpinner() {
        const label = this.dataset.label || '';
        this.classList.add('wt-qty-visible');
        this.innerHTML = `<span class="wt-quantity-total__label">${label}</span><span class="wt-qty-spinner" aria-hidden="true"></span>`;
      }

      getCurrentUnitPriceRaw() {
        const section = this._getSection();
        const subWidget = section?.querySelector('sub-widget');
        if (subWidget) {
          const selectedPlan = subWidget.querySelector('.wt-subscription-widget__plans--selected');
          if (selectedPlan) {
            const select = selectedPlan.querySelector('select');
            if (select) {
              const option = select.options[select.selectedIndex];
              const raw = Number(option?.dataset.priceRaw);
              if (raw) return raw;
            } else {
              const raw = Number(selectedPlan.dataset.priceRaw);
              if (raw) return raw;
            }
          }
        }
        return this.unitPriceRaw;
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'EUR';
        const locale = document.documentElement.lang || 'sk';
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
        }).format(cents / 100);
      }

      recalculate() {
        const qty = parseInt(this.qtyInput?.value || '1', 10);
        if (!qty || qty <= 1) {
          this.classList.remove('wt-qty-visible');
          return;
        }
        const unitPrice = this.getCurrentUnitPriceRaw();
        const total = unitPrice * qty;
        const label = this.dataset.label || '';
        this.innerHTML = `<span class="wt-quantity-total__label">${label}</span><span class="wt-quantity-total__price">${this.formatMoney(total)}</span>`;
        this.classList.add('wt-qty-visible');
      }
    }
  );
}
